import { Badge } from "@/components/ui/badge";
import type {
  DriverStatus,
  ExceptionType,
  LoadStatus,
  OrderStatus,
  ShipmentStatus,
} from "@/lib/api-types";

const statusColors: Record<string, string> = {
  completed: "bg-green-50 text-green-700 border-green-200",
  active: "bg-green-50 text-green-700 border-green-200",
  available: "bg-green-50 text-green-700 border-green-200",
  approved: "bg-green-50 text-green-700 border-green-200",
  failed: "bg-red-50 text-red-700 border-red-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  banned: "bg-red-50 text-red-700 border-red-200",
  denied: "bg-red-50 text-red-700 border-red-200",
  in_transit: "bg-blue-50 text-blue-700 border-blue-200",
  en_route: "bg-blue-50 text-blue-700 border-blue-200",
  at_stop: "bg-blue-50 text-blue-700 border-blue-200",
  assigned: "bg-yellow-50 text-yellow-700 border-yellow-200",
  accepted: "bg-yellow-50 text-yellow-700 border-yellow-200",
  pending: "bg-gray-50 text-gray-700 border-gray-200",
  off_duty: "bg-gray-50 text-gray-700 border-gray-200",
  inactive: "bg-gray-50 text-gray-700 border-gray-200",
  under_review: "bg-gray-50 text-gray-700 border-gray-200",
  late_delivery: "bg-orange-50 text-orange-700 border-orange-200",
  failed_stop: "bg-red-50 text-red-700 border-red-200",
  off_route: "bg-purple-50 text-purple-700 border-purple-200",
  driver_decline: "bg-yellow-50 text-yellow-700 border-yellow-200",
  admin: "bg-purple-50 text-purple-700 border-purple-200",
  dispatcher: "bg-blue-50 text-blue-700 border-blue-200",
  read_only: "bg-gray-50 text-gray-700 border-gray-200",
  own: "bg-blue-50 text-blue-700 border-blue-200",
  curri: "bg-amber-50 text-amber-700 border-amber-200",
  third_party: "bg-gray-50 text-gray-700 border-gray-200",
};

export function StatusBadge({
  status,
}: {
  status:
    | string
    | LoadStatus
    | OrderStatus
    | ShipmentStatus
    | DriverStatus
    | ExceptionType;
}) {
  const colors = statusColors[status] ?? "bg-gray-50 text-gray-700 border-gray-200";
  return (
    <Badge variant="outline" className={colors}>
      {status.replace(/_/g, " ")}
    </Badge>
  );
}
